/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgBandaid = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="m6.45 12.39 5.196 5.196 5.975-5.975-5.196-5.197zM13.84 5l5.194 5.194c1.406-1.49 1.384-3.787-.011-5.183-1.395-1.395-3.693-1.417-5.183-.01zm-3.609 14-5.195-5.196c-1.441 1.49-1.43 3.812-.024 5.219 1.407 1.406 3.73 1.418 5.22-.023zm-6.564-6.657 8.676-8.676c2.24-2.24 5.864-2.298 8.094-.069 2.23 2.23 2.171 5.854-.069 8.094l-8.676 8.676c-2.24 2.24-5.864 2.299-8.094.069-2.23-2.23-2.171-5.853.069-8.094z" />
        <path d="M11.293 9.879a1 1 0 1 1-1.415 1.414 1 1 0 0 1 1.415-1.414zm0 2.828a1 1 0 1 1-1.414 1.414 1 1 0 0 1 1.414-1.414zm2.828 0a1 1 0 1 1-1.414 1.414 1 1 0 0 1 1.414-1.414zm0-2.828a1 1 0 1 1-1.414 1.414 1 1 0 0 1 1.414-1.414z" />
      </g>
    </g>
  </Icon>
);
export { SvgBandaid as Bandaid };
